import React, {Component} from 'react'
import ProtectedElement from '../../../common/helpers/ProtectedElement'
import WithAjax from '../../../common/helpers/WithAjax'
import {compose} from 'recompose'
import {
  PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE
} from '../../../../constants'
import ActivateOrEditDirectorsCommentsPopup from '../../../production-admin/helpers/ActivateOrEditDirectorsCommentsPopup'

class DirectorsCommentsBox extends Component {
  constructor(props){
    super(props);
    this.state = {
      directorsComments: this.props.directorsComments
    }

    this.sendData = this.sendData.bind(this);
  }

  sendData(){
      let url = 'skillVendors/' + this.props.skillVendorId + '/profiles/voiceactor';
      this.props.ajax.get(url, true, (data) => {
        this.setState({
          directorsComments: data.DirectorsComments
        });
      });
  }

  render() {
    return (
      <div className="col-md-6 widget">
        <div className="title">Director's comments</div>
        <div className="row">
          <div className="col-12 directors-comments">
            {this.state.directorsComments}
          </div>
          <ProtectedElement permission={PERMISSION_TALENTS_PROFILE_VOICEACTOR_WRITE}>
            <div className="row">
              <div className="col-6 mt-3">
                <ActivateOrEditDirectorsCommentsPopup skillVendorId={this.props.skillVendorId} sendData={this.sendData} />
              </div>
            </div>
            </ProtectedElement>
        </div>
      </div>
    )
  }
}
export default compose(
  WithAjax)(DirectorsCommentsBox)
